import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HelpersService } from '../../../../services/helpers.service';
import { ProductsService } from '../../../../services/products.service';
import { LookupService } from '../../../../services/lookup.service';
import { AppConfig } from '../../../../app.config';
import { PosIntegrationService } from '../../../../services/pos-integration.service';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
//TREK 1.18 FEATURE START
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WorkshopJobcardCreateCollectionComponent } from '../../../modals/workshop-jobcard/workshop-jobcard-quote-search-area/workshop-jobcard-create-collection/workshop-jobcard-create-collection.component';
import { WorkshopJobcardManageCollectionsComponent } from '../../../modals/workshop-jobcard/workshop-jobcard-quote-search-area/workshop-jobcard-manage-collections/workshop-jobcard-manage-collections.component';
import { PosProductsAddToCollectionComponent } from './add-to-collection/pos-products-add-to-collection.component';
import { forkJoin } from 'rxjs';
//TREK 1.18 FEATURE END


@Component({
  selector: 'app-pos-products',
  templateUrl: './pos-products.component.html',
  styleUrls: ['./pos-products.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [MessageService]
})
export class PosProductsComponent implements OnInit {
  public products: any = [];
  public gearTypes: any = [];
  public loading: boolean = false;
  public currencySymbol = '';
  public VATInclusive = true;
  public VATRate = 0.15;
  public replacement = [];

  public canManageProducts = false;
  public showProductDetail = false;
  public selectedProduct: any = {};

  public globalSelectValue: any;
  public busyBulkActioning: boolean = false;
  public selectedProducts: any = [];

  //TREK 1.18 FEATURE START
  public searchTerm: string = '';
  public collections: any[] = [];
  public createdCollections: any[] = [];
  public selectedCollection: any = { id: 'ALL' };
  public searchedTerm: string = '';
  public searched: boolean = false;
  public searching: boolean = false;
  public selectedCollectionData: any[] = [];
  public pageSize: number = 50;
  public first: number = 0;
  //TREK 1.18 FEATURE END

  public columns: any = [
    {
      header: this.translate.instant('general.headers.sku'),
      field: 'SKU',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.name'),
      field: 'Name',
      type: 'string',
      width: '16%'
    },
    {
      header: this.translate.instant('general.headers.brand'),
      field: 'Brand',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.ean'),
      field: 'EAN',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.upc'),
      field: 'UPC',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.manufacturer_sku'),
      field: 'ManufacturerSKU',
      type: 'string',
    }
  ];

  constructor(
    private helpersService: HelpersService,
    private productsService: ProductsService,
    private lookupService: LookupService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private posIntegrationService: PosIntegrationService,
    private router: Router,
    private appConfig: AppConfig,
    private confirmationService: ConfirmationService,
    public messageService: MessageService,
  ) {
    this.getGearTypes();
    //this.products = this.helpersService.getProductData();
    this.products = [];  //TREK 1.18

    var partnerData = helpersService.getPartnerData();
    this.currencySymbol = partnerData.CurrencySymbol;
    this.VATInclusive = partnerData.VATInclusive;
    this.VATRate = partnerData.VATRate;

    this.columns.push({
      header: this.translate.instant('bikeshop.products.excl_vat'),
      field: 'UnitPrice',
      type: 'currency',
    });

    this.columns.push({
      header: this.translate.instant('bikeshop.print.tax'),
      field: 'Tax',
      type: 'currency',
    });

    this.columns.push({
      header: this.translate.instant('bikeshop.products.incl_vat'),
      field: 'UnitPrice_IncludingTax',
      type: 'currency',
    });
    //TREK 1.18
    this.columns.push({
      header: this.translate.instant('general.headers.marked_as_labour_product'),
      field: 'MarkedAsLabourProduct',
      type: 'checkbox',
    });
    // TREK 1.18

    if (this.VATInclusive) {
    } else {
    }

    //if (this.VATInclusive) {
    //  this.columns.push({
    //    header: this.translate.instant('general.headers.price'),
    //    field: 'UnitPrice_IncludingTax',
    //    type: 'currency'
    //  });
    //} else {
    //  this.columns.push({
    //    header: this.translate.instant('general.headers.price'),
    //    field: 'UnitPrice',
    //    type: 'currency'
    //  });
    //}


    //TREK 1.18 FEATURE
    this.collections = [{
      id: 'ALL',
      collectionName: this.translate.instant('general.all'),
      selected: true,
    }];
    //TREK 1.18 FEATURE END
  }


  ngOnInit() {
    this.checkIntegration();
    this.getCollections();
  }

  checkIntegration() {
    const partner = this.helpersService.getPartnerData();

    if (
      this.appConfig
        .getSupportedPOSSystems()
        .map((x) => {
          return x.POSID;
        })
        .indexOf(partner.POSSystemID) > -1
    ) {
      this.posIntegrationService
        .checkPOSIntegration(partner.ID, partner.POSSystemID)
        .subscribe(
          (result) => {
            this.canManageProducts = false;
          },
          (err) => {
            this.canManageProducts = true;
          },
        );
    } else if (partner.POSSystemID <= 0) {
      this.canManageProducts = true;
    }

  }


  //TREK 1.18 FEATURE
  search() {
    const term = (this.searchTerm || '').trim();

    // The endpoint returns nothing for fewer than 2 characters
    if (term.length < 2) {
      return;
    }
    if (this.selectedCollection && this.selectedCollection.id !== 'ALL') {
      const lower = term.toLowerCase();
      const startsWith = (value) => (value || '').toString().toLowerCase().startsWith(lower);

      this.searched = true;
      this.searchedTerm = term;
      this.globalSelectValue = false;
      this.products = this.selectedCollectionData
        .filter((item) => startsWith(item.SKU) || startsWith(item.Name) || startsWith(item.EAN) ||
          startsWith(item.UPC) || startsWith(item.ManufacturerSKU));
      this.first = 0;
      return;
    }
    this.searching = true;
    this.searched = true;
    this.searchedTerm = term;

    this.productsService
      .searchProductV2(this.helpersService.getPartnerId(), term)
      .subscribe(
        (results) => {
          const products = results && results.products ? results.products : [];

          this.products = products.map((item) => {
            return {
              ID: item.ID,
              SKU: item.Description,
              Name: item.Data,
              Brand: item.Brand,
              EAN: item.EAN,
              UPC: item.UPC,
              ManufacturerSKU: item.ManufacturerSKU,
              UnitPrice: item.UnitPrice,
              UnitPrice_IncludingTax: item.UnitPrice_IncludingTax,
              Tax: item.Tax,
              Type: item.Type,
              MarkedAsLabourProduct: item.MarkedAsLabourProduct,
              selected: false,
            };
          }).sort((a, b) => (a.Name || '').localeCompare(b.Name || ''));

          this.globalSelectValue = false;
          this.first = 0;
          this.searching = false;
        },
        (err) => {
          this.searching = false;
        },
      );
  }

  onSearchTermChange(value: string) {
    if (!value || value.trim().length === 0) {
      this.clearSearch();
    }
  }

  clearSearch() {
    this.searchTerm = '';
    this.searchedTerm = '';
    this.globalSelectValue = false;
    this.first = 0;

    if (this.selectedCollection && this.selectedCollection.id !== 'ALL') {
      this.products = this.selectedCollectionData;
    } else {
      this.searched = false;
      this.products = [];
    }
  }

  getCollections() {
    this.productsService.getProductCollections(this.helpersService.getPartnerId()).subscribe((result) => {
      this.createdCollections = result || [];

      // "All" first, always (1.4.1, 1.4.4). No Service Types pill (1.4.3).
      this.collections = [{
        id: 'ALL',
        collectionName: this.translate.instant('general.all'),
      }];

      this.createdCollections.forEach((collection) => {
        this.collections.push({
          id: collection.id,
          collectionName: collection.collectionName,
          count: collection.count || 0,
        });
      });

      // Keep the current pill selected after a reload (e.g. after creating a collection)
      const selectedId = this.selectedCollection ? this.selectedCollection.id : 'ALL';
      const selected = this.collections.find((col) => col.id === selectedId) || this.collections[0];
      selected.selected = true;
      this.selectedCollection = selected;
    });
  }

  createCollection() {
    const modalRef = this.modalService.open(WorkshopJobcardCreateCollectionComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window'
    });

    modalRef.result.then(
      (result) => { this.getCollections(); },
      (onrejected) => { this.getCollections(); },
    );
  }

  manageCollections() {
    const modalRef = this.modalService.open(WorkshopJobcardManageCollectionsComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window'
    });

    modalRef.componentInstance.collections = this.createdCollections;

    modalRef.result.then(
      (result) => { this.getCollections(); },
      (onrejected) => { this.getCollections(); },
    );
  }

  collectionSelected(collection) {
    if (collection.id !== 'ALL' && !collection.count) {
      return;
    }
    this.searchTerm = '';
    this.searchedTerm = '';
    this.globalSelectValue = false;

    this.collections.forEach((col) => {
      col.selected = col.id === collection.id;
    });
    this.selectedCollection = collection;

    if (collection.id === 'ALL') {
      this.selectedCollectionData = [];
      this.products = [];
      this.searched = false;
      return;
    }

    this.loadCollectionProducts(collection);
  }

  loadCollectionProducts(collection) {
    this.searching = true;
    this.searched = true;
    this.products = [];

    this.productsService.getProductCollectionData(this.helpersService.getPartnerId(), collection.id).subscribe((result) => {
      this.selectedCollectionData = (result || [])
        .filter((item) => item.partnerID > 0)
        .map((item) => {
          return {
            ID: item.internalProductID,
            ProductCollectionLinkID: item.id,
            SKU: item.sku,
            Name: item.name,
            Brand: item.brand,
            EAN: item.ean,
            UPC: item.upc,
            ManufacturerSKU: item.manufacturerSKU,
            UnitPrice: item.unitPrice,
            Tax: item.tax,
            UnitPrice_IncludingTax: item.unitPrice_IncludingTax,
            MarkedAsLabourProduct: item.markedAsLabourProduct ?? false,
            selected: false,
          };
        })
        .sort((a, b) => (a.Name || '').localeCompare(b.Name || ''));

      this.products = this.selectedCollectionData;
      this.first = 0;
      this.searching = false;
    }, (err) => {
      this.searching = false;
    });
  }

  addToCollection() {
    var productIDs = this.products.filter(x => x.selected).map(x => x.ID);
    if (productIDs.length === 0) {
      return;
    }

    const modalRef = this.modalService.open(PosProductsAddToCollectionComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window'
    });

    modalRef.componentInstance.collections = this.collections.filter(c => c.id !== 'ALL');
    modalRef.componentInstance.currentCollectionId = this.selectedCollection?.id;
    modalRef.componentInstance.productIDs = productIDs;

    modalRef.result.then(
      (result) => {
        // Saved: untick everything and reload the pill counts
        this.products.forEach(x => x.selected = false);
        this.globalSelectValue = false;
        this.getCollections();
      },
      (dismissed) => { },
    );
  }

  removeFromCollection() {
    if (!this.selectedCollection || this.selectedCollection.id === 'ALL') {
      return;
    }
    var selected = this.products.filter(x => x.selected && x.ProductCollectionLinkID);
    if (selected.length === 0) {
      return;
    }

    this.busyBulkActioning = true;
    var partnerId = this.helpersService.getPartnerId();
    var calls = selected.map(x => this.productsService.deleteProductCollectionLink(partnerId, x.ProductCollectionLinkID));

    forkJoin(calls).subscribe(() => {
      this.afterRemoveFromCollection();
    }, err => {
      // Some may have been removed, so reload either way to show what's really left
      this.afterRemoveFromCollection();
    });
  }

  afterRemoveFromCollection() {
    this.busyBulkActioning = false;
    this.globalSelectValue = false;
    this.getCollections();                                  // update the pill counts
    this.loadCollectionProducts(this.selectedCollection);   // reload what's left in the collection
  }

  markProductForLabour(product, col) {
    if (col.field !== 'MarkedAsLabourProduct') {
      return;
    }

    var newValue = product.MarkedAsLabourProduct;
    this.productsService.saveProductLabour(product.ID, newValue).subscribe(
      (result) => { },
      (err) => {
        product.MarkedAsLabourProduct = !newValue;
      },
    );
  }

  onPageChange(event) {
    this.first = event.first;
    this.products.forEach(x => x.selected = false);
    this.globalSelectValue = false;
  }

  getCurrentPageProducts() {
    return this.products.slice(this.first, this.first + this.pageSize);
  }

  //TREK 1.18 FEATURE END


  refreshPOSProducts() {
    // this.getProducts();
    this.syncAndCacheProducts();
  }
  // Still syncs from the POS and refreshes the saved product list other screens use,
  // but doesn't put every product in the table (1.1). It reloads what the user was looking at instead.
  syncAndCacheProducts() {
    this.loading = true;
    var partnerData = this.helpersService.getPartnerData();
    if (partnerData.POSSystemID <= 10) {
      this.productsService
        .getAllProductsWithGear(this.helpersService.getPartnerId())
        .subscribe((products) => {
          this.helpersService.saveProductData(products);
          this.afterSync();
        }, err => {
          this.afterSync();
        });
    } else {
      this.productsService
        .syncNewProducts(partnerData.ID)
        .subscribe(() => {
          this.productsService
            .getAllProductsWithGear(this.helpersService.getPartnerId())
            .subscribe((products) => {
              this.helpersService.saveProductData(products);
              this.afterSync();
            }, err => {
              this.afterSync();
            });
        }, err => {
          this.afterSync();
        });
    }
  }

  afterSync() {
    this.loading = false;
    this.busyBulkActioning = false;
    this.reloadCurrentView();
  }

  // Reloads whatever the user was looking at: the open collection, or the last search.
  // On "Start searching" nothing loads (1.3.1).
  reloadCurrentView() {
    if (this.selectedCollection && this.selectedCollection.id !== 'ALL') {
      this.loadCollectionProducts(this.selectedCollection);
    } else if (this.searchedTerm) {
      this.searchTerm = this.searchedTerm;
      this.search();
    }
  }

  // Take products out of the table and out of the loaded collection
  removeProductsFromPage(productIDs: number[]) {
    this.products = this.products.filter(x => productIDs.indexOf(x.ID) === -1);
    this.selectedCollectionData = this.selectedCollectionData.filter(x => productIDs.indexOf(x.ID) === -1);
  }

  // The saved product list (job card, linked SKUs, insurance etc. read it)
  removeCachedProducts(productIDs: number[]) {
    var cached = this.helpersService.getProductData() || [];
    this.helpersService.saveProductData(cached.filter(x => productIDs.indexOf(x.ID) === -1));
  }

  updateCachedProduct(product) {
    var cached = this.helpersService.getProductData() || [];
    var values = {
      ID: product.id,
      SKU: product.sku,
      Name: product.name,
      Brand: product.brand,
      UPC: product.upc,
      EAN: product.ean,
      ManufacturerSKU: product.manufacturerSKU,
      UnitPrice: product.unitPrice,
      UnitPrice_IncludingTax: product.unitPrice_IncludingTax,
    };
    var found = cached.find(x => x.ID === product.id);
    if (found) {
      Object.assign(found, values);
    } else {
      cached.push(values);
    }
    this.helpersService.saveProductData(cached);
  }

  getGearTypes() {
    this.lookupService.getGearTypes().subscribe((gearTypes) => {
      this.gearTypes = gearTypes;
    });
  }

  getProducts() {
    this.loading = true;
    var partnerData = this.helpersService.getPartnerData();
    if (partnerData.POSSystemID <= 10) {
      this.productsService
        .getAllProductsWithGear(this.helpersService.getPartnerId())
        .subscribe((products) => {
          this.helpersService.saveProductData(products);
          this.products = products;
          this.loading = false;
          this.busyBulkActioning = false;
        });
    } else {
      this.productsService
        .syncNewProducts(partnerData.ID)
        .subscribe((products) => {
          this.productsService
            .getAllProductsWithGear(this.helpersService.getPartnerId())
            .subscribe((products) => {
              this.helpersService.saveProductData(products);
              this.products = products;
              this.loading = false;
              this.busyBulkActioning = false;
            }, err => {
              this.busyBulkActioning = false;
            });
        });
    }
  }

  setReplacement(product) {
    const item = this.replacement.find((x) => x.ID === product.ID);
    if (item) {
      this.replacement = this.replacement.filter((x) => x.ID !== product.ID);
    } else {
      this.replacement.push(product);
    }
  }

  clearReplacement = () => {
    this.replacement = [];
  };

  closeProductDetail() {
    this.showProductDetail = false;
  }

  productUpdated(product) {
    this.showProductDetail = false;
    if (product.deleted) {
      this.removeProductsFromPage([product.id]);
      this.removeCachedProducts([product.id]);
      this.getCollections();
      return;
    }
    this.updateCachedProduct(product);
    this.reloadCurrentView();
  }

  addProduct() {
    this.selectedProduct = {
      taxable: true,
    };
    this.showProductDetail = true;
  }

  editProduct(product) {
    if (this.canManageProducts) {
      this.selectedProduct = {
        id: product.ID,
        sku: product.SKU,
        name: product.Name,
        brand: product.Brand,
        type: product.Type,
        manufacturerSKU: product.ManufacturerSKU,
        ean: product.EAN,
        upc: product.UPC,
        taxable: product.Tax > 0,
        defaultPrice: null,
      };
      this.showProductDetail = true;
    }
  }

  importProducts() {
    this.router.navigateByUrl('/store/import-products');
  }

  isProductsSelected() {
    var isSelected = false;
    this.products.forEach(x => {
      if (x.selected) {
        isSelected = true;
      }
    });
    return isSelected;
  }

  globalSelected(event) {
    this.products.forEach(x => x.selected = false);
    if (event.checked) {
      this.getCurrentPageProducts().forEach(x => {
        x.selected = true;
      });
    }
  }

  bulkDelete() {
    var selectedProducts = this.products.filter(x => x.selected)
      .map(x => x.ID);
    var count = selectedProducts.length;
    if (count == 0) {
      return;
    }


    this.confirmationService.confirm({
      icon: '',
      header: this.translate.instant('bikeshop.pos_products.bulk_delete_selected'),
      acceptLabel: this.translate.instant("bikeshop.general.delete"),
      rejectLabel: this.translate.instant("general.cancel"),
      rejectButtonStyleClass: 'alternate',
      message:
        this.translate.instant("bikeshop.pos_products.bulk_delete_selected_description", { count: count }),
      accept: () => {
        this.busyBulkActioning = true;
        var data = {
          ClearAllProducts: false,
          ProductIDs: selectedProducts
        }

        this.productsService.removePOSProducts(this.helpersService.getPartnerId(), data).subscribe(res => {
          this.removeProductsFromPage(selectedProducts);
          this.removeCachedProducts(selectedProducts);
          this.getCollections();
          this.busyBulkActioning = false;
          this.globalSelectValue = false;
          this.messageService.add({
            detail: this.translate.instant("bikeshop.pos_products.bulk_delete_completed"),
            key: "bottom-center"
          })
        }, err => {
          this.busyBulkActioning = false;
        })
      },
    });
  }

  selectProductCheck(event) {
    if (!event.checked) {
      this.globalSelectValue = false;
    }
  }
}
